<ul *ngIf="navigated$ | async">
  <li *ngFor="let link of topNavigationLinks || []">
    <app-feature-menu-item [featureLink]="link"></app-feature-menu-item>
  </li>
</ul>
